import {
  ProOrganizerRequestEntity as SdkProOrganizerRequestEntity,
  ProOrganizerRequestHistoryEntity,
} from "@smatchy/sdk";

export interface UserSnapshot {
  displayName?: string;
  email?: string;
}

export interface Snapshot {
  key: string;
  value: string;
  description?: string;
}

export interface ProofGroup {
  proofType: string;
  proofs: string[];
}

export class ProOrganizerRequestEntity implements SdkProOrganizerRequestEntity {
  id: string;
  _id?: string;
  userId: string;
  userSnapshot?: UserSnapshot;
  premiumRoleId: string;
  premiumRoleSnapshot?: Snapshot;
  proofs: string[];
  note?: string;
  companyName?: string;
  companyAddress?: string;
  siretRnaNumber?: string;
  insuranceProofs?: string[];
  insuranceExpirationDate?: string;
  proofGroups?: ProofGroup[];
  histories?: ProOrganizerRequestHistoryEntity[];
}